// finds instances where words have been joind together with / \ or -
const pipeFinder = /\|/g;
const softhypenFinder = /\||\u00AD/g;

export const insertOptionalWordbreaks = (value: string) => {
  return value && value.replace(pipeFinder, '\u00AD');
};

export const removeSoftHyphens = (value:string) => {
  return value && value.replace(softhypenFinder, '');
};

const segmentFinder = /{(\d+)}/g;
export const replaceTemplateString = (text:string, ...rest) => {
  return text && text.replace(segmentFinder, (match:string, group:string) => {
    return rest[group];
  });
};

// For use for for instance alphabetical indexes, where the first letter of a word
// is put into a "category". Eg. "Hello" -> "H", "Ålborg" -> "Å", "étc" -> "E"
const letterRegex = /^[a-zæøå]$/i;
const numberRegex = /^[0-9]$/;
export const getCharacterCategory = (str: string) => {
  if (!str || !str.length) {
    return undefined;
  }

  let firstCharacter = str.substring(0, 1);
  if (letterRegex.test(firstCharacter)) {
    return firstCharacter.toUpperCase();
  }
  
  // Removes phonemes like è -> e
  // https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript  
  str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  firstCharacter = str.substring(0, 1);

  if (letterRegex.test(firstCharacter)) {
    return firstCharacter.toUpperCase();
  }
  else if (numberRegex.test(firstCharacter)) {
    return '#';
  }
  return '-';
};
